import {
  ActionsPage
  AppView
  DisabledRelations
  DisabledTypes
  GraphColors
  Macro
  MemberKeys
  NameKeys
  Namespaces
  RelationLabels
  SpreadSheetView
  TypeColors
  TypeSizes
} from '../'
import ConfigQuery from '../ConfigQuery'
import { branch, namespaces } from '../constants'

classes = {
  ActionsPage
  AppView
  DisabledRelations
  DisabledTypes
  GraphColors
  Macro
  MemberKeys
  NameKeys
  Namespaces
  RelationLabels
  SpreadSheetView
  TypeColors
  TypeSizes
}

DISABLED_RELATIONS = 'disabledRelations'
DISABLED_TYPES = 'disabledTypes'
MEMBER_KEYS = 'memberKeys'
NAME_KEYS = 'nameKeys'
NAMESPACES = 'namespaces'
TYPECOLORS = 'typeColors'
TYPESIZES = 'typeSizes'
GRAPHCOLORS = 'graphColors'
RELATION_LABELS = 'relationLabels'

module.exports = ->
  await Weaver.Node.batchSave(
    _.map(classes, ({ className }) ->
      new Weaver.Node(className).set('name', className)
    )
  , { branch, commitMessage: "Instantiate config classes." })

  await new MemberKeys().update(['type'])
  await new NameKeys().update(['name'])
  await new Namespaces()
    .set('enabled', true)
    .updateMap(namespaces)
  await new DisabledRelations().update([])
  await new DisabledTypes().update([])
  await new TypeColors().update({ 'undefined': '#EEEEEE' })
  await new GraphColors().update({ 'undefined': '#EEEEEE' })
  await new TypeSizes().update({})
  await new RelationLabels().update({})
